import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/index';
import cookie from 'react-cookies';
import {fromJS} from "immutable";

const CURRENT_USER_COOKIE = "CURRENT_USER_COOKIE";
const REDUCER_SESSION_STATE = "REDUCER_SESSION_STATE";

const sessionMiddleware = store => next => action => {
    let result = next(action);
    sessionStorage.setItem(REDUCER_SESSION_STATE, JSON.stringify(store.getState()));
    return result;
};

let initialState = {};

let userCookie = cookie.loadAll();

if (userCookie[CURRENT_USER_COOKIE]) {
    let savedState = JSON.parse(sessionStorage.getItem(REDUCER_SESSION_STATE));

    for (let prop in savedState) {
        if (prop === "themeReducer") {
            initialState[prop] = {...savedState[prop]};
            continue;
        }

        initialState[prop] = fromJS(savedState[prop]);
    }
}

const store = createStore(rootReducer, initialState, applyMiddleware(sessionMiddleware));

export default store;
